export const eur = (v) => {
  const n = Number(v || 0);
  return n.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " \u20ac";
};

export const lineTotal = (it) => {
  const base = (Number(it.quantity) || 0) * (Number(it.price) || 0);
  const disc = Number(it.discount) || 0;
  return base - base * (disc / 100);
};

export const pct = (v) => {
  const n = Number(v || 0);
  const s = n.toLocaleString("es-ES", { maximumFractionDigits: 2 });
  return `${s} %`;
};

export const fmtQty = (v) => {
  const n = Number(v);
  if (isNaN(n)) return v;
  return Number.isInteger(n) ? String(n) : n.toLocaleString("es-ES", { maximumFractionDigits: 3 });
};

export const fmtDate = (v) => {
  if (!v) return "";
  if (/^\d{4}-\d{2}-\d{2}/.test(v)) {
    const [y, m, d] = v.slice(0, 10).split("-");
    return `${d}/${m}/${y}`;
  }
  return v;
};

export const quoteFileName = (q) => {
  const name = (q.client_name || "SinCliente")
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // strip accents
    .replace(/[^a-zA-Z0-9]/g, ""); // remove spaces and symbols
  return `${name || "SinCliente"}_PS${q.number}.pdf`;
};
